import Vue from 'vue'
import axios from 'axios'

// --- ACCIÓN NUEVA PARA APP.VUE Y LOGIN ---
export async function fetchEmpresaPublic(context) {

    if (context.state.empresa && context.state.empresa.nombre) return

    try {

        const response = await axios.get('/empresas/public')

        context.commit('SET_EMPRESA', response.data)

        return response.data

    } catch (e) {

        console.error("Error obteniendo info de empresa:", e)
        throw e

    }
}

// --- TUS FUNCIONES EXISTENTES (Optimización sugerida) ---

export async function registrar_empresa(context, data) {
    context.commit('setLoadingInit', true, { root: true });
    try {
        const response = await axios.post('/empresas/', data);
        return response;
    } finally {
        context.commit('setLoadingInit', false, { root: true });
    }
}

export async function actualizar_empresa(context, {data, uuid_empresa}) {
    context.commit('setLoading', true, { root: true });
    try {
        const response = await axios.put(`/empresas/${uuid_empresa}`, data);
        return response;
    } finally {
        context.commit('setLoading', false, { root: true });
    }
}

// Esta función parece ser un helper simple, la mantenemos
export const get_empresa = () => {
    return axios.get(`/empresas/`);
};

export async function actualizar_datos(context) {
    context.commit('setLoading', true, { root: true });
    try {
        const response = await axios.get(`/productos/actualizardatos`);
        return response;
    } finally {
        context.commit('setLoading', false, { root: true });
    }
}

export async function get_pedido_con_detalle(context, id) {
    context.commit('setLoading', true, { root: true });
    try {
        const response = await Vue.axios.get(`/pedidos/${id}`);
        context.commit('set_pedido_con_detalle', response.data);
    } catch (error) {
        console.log("ERROR EN pedido detalle: " + error);
    } finally {
        context.commit('setLoading', false, { root: true });
    }
}